import envConfig from '../envs/envConfig';

export default () => {
  const { remotes } = envConfig;
  const { search } = window.location;
  const scopes = remotes?.map((remote) => remote.scope);

  const query = new URLSearchParams(search);
  const rawQueryObject = Object.fromEntries?.(query);
  const rawQueryKeys = rawQueryObject && Object.keys(rawQueryObject);

  if (scopes && rawQueryKeys?.length) {
    return rawQueryKeys
      .filter((key) => scopes.includes(key))
      .reduce((previous, key) => {
        return {
          ...previous,
          [key]: rawQueryObject[key],
        };
      }, {});
  }

  return undefined;
};
